<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9556 4.875H4.875V11.1967H10.9556V4.875Z" stroke="#6C757D" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M19.1246 4.875H13.0439V11.1967H19.1246V4.875Z" stroke="#6C757D" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M10.9556 12.8037H4.875V19.1255H10.9556V12.8037Z" stroke="#6C757D" stroke-width="0.75" stroke-miterlimit="10"/>
<path d="M19.1246 12.8037H13.0439V19.1255H19.1246V12.8037Z" stroke="#6C757D" stroke-width="0.75" stroke-miterlimit="10"/>
</svg>
